// extracted by mini-css-extract-plugin
export default {"dropzone":"FileDropper_dropzone__DCnYo","dropHereText":"FileDropper_dropHereText__eLtR8","draggingFile":"FileDropper_draggingFile__7KXZZ","dragOver":"FileDropper_dragOver__ucfBw"};